/**
 * Floating banner geometry and state machine (prototype `setupHero`).
 *
 * The banner wrapper keeps the banner's full height and is `position: sticky` at a negative `top`, so once the page
 * has scrolled far enough exactly the slim (compact) height stays visible under the header. At that scroll position
 * the banner switches to its compact layout. A 2px hysteresis band avoids flicker around the threshold.
 */
export interface HeroGeometry {
  /** sticky `top` for the wrapper */
  top: number;
  /** scroll position where only the slim height is still visible */
  at: number;
}

export function heroGeometry(docTop: number, headerHeight: number, fullHeight: number, slimHeight: number): HeroGeometry {
  return {
    top: headerHeight - (fullHeight - slimHeight),
    at: docTop - headerHeight + (fullHeight - slimHeight),
  };
}

/** Next compact state. `on === null` means "not applied yet" (first evaluation after a render). */
export function nextCompact(on: boolean | null, scrollY: number, at: number): boolean {
  return on ? scrollY > at - 2 : scrollY >= at + 2;
}

/** Which one-shot animation class to play for a state change (none on the first apply after a render). */
export function transitionClass(was: boolean | null, now: boolean): 'slim-in' | 'expand' | null {
  if (was === null || was === now) return null;
  return now ? 'slim-in' : 'expand';
}
